var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusCircleFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#FFF2F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.75C28 22.8516 23.0586 27.75 17 27.75C10.8984 27.75 6 22.8516 6 16.75C6 10.6914 10.8984 5.75 17 5.75C23.0586 5.75 28 10.6914 28 16.75ZM17 7.8125C12.0586 7.8125 8.0625 11.8516 8.0625 16.75C8.0625 21.6914 12.0586 25.6875 17 25.6875C21.8984 25.6875 25.9375 21.6914 25.9375 16.75C25.9375 11.8516 21.8984 7.8125 17 7.8125Z",
    fill: "#EF4136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCircleFailed);
export default __webpack_public_path__ + "static/media/status-circle-failed.d946bec69ef80ec0cecc832ce4b15b8a.svg";
export { ForwardRef as ReactComponent };